import { Fragment, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { setUserEntry, LogOut, updateStationId } from "../../server/Customer";
import { globalFileIcon } from "../../../axiosInstance";
import { useDispatch } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Accessibility from "../Accessibility";
import CustomerService from "../customerService/CustomerService";
import PrivateAreaList from "../privateArea/PrivateAreaList";
import { setToggleCart } from "../../server/CartsOpen";
import { FiArrowRight } from "react-icons/fi";
import {
  GetStation,
  GetStationsToUser,
  getStationsFromPGW,
} from "../../server/Station";
import HeaderSearch from "./HeaderSearch";
import { updateToken } from "../../server/Customer";
import { setToggleMenu } from "../../server/CartsOpen";
import { set } from "react-hook-form";

const HeaderConnection = ({
  setAdminToCustomer,
  user,
  stationId,
  role,
  setAllProduct,
  haveGetToken,
  basicHeader,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);
  const [openPrivateAreaList, setOpenPrivateAreaList] = useState(false);
  const [userStation, setUserStation] = useState(null);
  const [adminStation, setAdminStation] = useState([]);
  const { selectStation, toggleMenu } = useSelector((state) => ({
    selectStation: state.user.stationId,
    toggleMenu: state.openCart.toggleMenu,
  }));

  const handleNavigation = () => {
    dispatch(setToggleCart(false));
    navigate("/about");
  };

  const exit = (haveGetToken) => {
    navigate("/");
    dispatch(LogOut());
    haveGetToken(haveGetToken);
  };

  const check = async (stationId) => {
    const newStationId = stationId === "678430" ? 4 : stationId;
    await updateToken(newStationId);
    dispatch(updateStationId(stationId));
    if (user) {
      user.StationId = stationId;
    }
  };

  useEffect(() => {
    if (role) {
      GetStationsToUser(user?.Id)
        .then((x) => {
          getStationsFromPGW().then((stations) => {
            setAdminStation(
              stations.data.filter((station) =>
                x.data.some(
                  (stat) => stat.Id === station.id || station.id === "678430",
                ),
              ),
            );
          });
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      GetStation(selectStation).then((x) => setUserStation(x.data));
    }
  }, [user, stationId, selectStation]);

  const changeProductDisplay = (value) => {
    switch (value) {
      case "allProduct":
        setAdminToCustomer(true);
        setAllProduct(true);
        break;
      case "active":
        setAdminToCustomer(true);
        setAllProduct(false);
        break;
      case "customer":
        setAdminToCustomer(false);
        setAllProduct(false);
        break;
      default:
        console.warn("ערך לא מוכר:", value);
    }
  };

  return (
    <div className="header-connection">
      <div className="back-and-logo">
        <button className="back-button" onClick={() => navigate(-1)}>
          <FiArrowRight />
        </button>
        {!basicHeader && (
          <NavLink to="/" className="site-icon">
            <img
              loading="lazy"
              src={globalFileIcon + "site-icon.svg"}
              alt="site"
            />
          </NavLink>
        )}
      </div>
      {role && !basicHeader && (
        <NavLink to="/admin/coupons">
          <img src={globalFileIcon + "gear.svg"} alt="menu" />
        </NavLink>
      )}
      {!basicHeader ? (
        <>
          <div className="header-data">
            <li
              className={openMenu ? "data open-menu" : "data"}
              onClick={() => setOpenMenu(true)}
            >
              <img
                loading="lazy"
                src={globalFileIcon + "customer-service.svg"}
                alt="customer-service"
              />
              <a className="customer-service">שירות לקוחות</a>
            </li>
            {openMenu ? (
              <div className="customer-service-menu">
                <CustomerService setOpenMenu={setOpenMenu} />
              </div>
            ) : null}
            <Accessibility />
          </div>
          <HeaderSearch />
        </>
      ) : (
        <h2>פאנל הניהול</h2>
      )}

      <div className="login-or-sign-in">
        {!user || user.UserTypeId === 5 ? (
          <div>
            <button
              className="login"
              onClick={() => dispatch(setUserEntry([true, "login"]))}
            >
              כניסה
            </button>
            <button
              className="sign-in"
              onClick={() => dispatch(setUserEntry([true, "signIn"]))}
            >
              הרשמה
            </button>
          </div>
        ) : (
          <Fragment>
            <div>
              {" "}
              {role && !basicHeader && (
                <button>
                  <select
                    className="custom-select"
                    onChange={(e) => changeProductDisplay(e.target.value)}
                  >
                    <option value="allProduct">תצוגת כל המוצרים</option>
                    <option value="active">תצוגת פעילים</option>
                    <option value="customer">תצוגת לקוח</option>
                  </select>
                </button>
              )}
              {role ? (
                <button className="btn-to-private-area station-user">
                  מנהל /{" "}
                  <select
                    onChange={(e) => check(e.target.value)}
                    className="custom-select"
                  >
                    {stationId ? (
                      <option value={stationId}>
                        {adminStation.find((stat) => stat.id === stationId)
                          ?.name || "בחר תחנה"}
                      </option>
                    ) : (
                      <option value="">בחר תחנה</option>
                    )}

                    {adminStation
                      .filter((stat) => stat.id !== stationId)
                      .map((station) => (
                        <option key={station.id} value={station.id}>
                          {station.name}
                        </option>
                      ))}
                  </select>
                </button>
              ) : (
                <button className="btn-to-private-area station-user">
                  <span className="custom-customer">
                    תחנת {userStation?.Name}
                  </span>
                </button>
              )}
              {!user.UserTypeId ? (
                <Fragment>
                  <button
                    onClick={() => setOpenPrivateAreaList(true)}
                    className="btn-to-private-area"
                  >
                    <span>
                      לאזור האישי של {user.Name} {user.LastName}
                    </span>
                  </button>
                  {openPrivateAreaList ? (
                    <div className="private-area-list-menu">
                      <PrivateAreaList
                        setOpenPrivateAreaList={setOpenPrivateAreaList}
                      />
                    </div>
                  ) : null}
                </Fragment>
              ) : null}
              <button onClick={() => exit(haveGetToken)} className="exit">
                <span>יציאה</span>
              </button>
              {role && (
                <>
                  {basicHeader ? (
                    <NavLink to="/">
                      <img
                        src={globalFileIcon + "close-menu.svg"}
                        alt="close"
                      />
                    </NavLink>
                  ) : null}
                </>
              )}
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default HeaderConnection;
